import {
  Bone,
  HeaderSkeleton,
  Line,
  placeholderKeys,
  SkeletonRegion,
  TableSkeleton,
} from '@ems/ui/patterns/skeleton-blocks'

const NAV_KEYS = placeholderKeys('nav', 8)

export function ShellSkeleton() {
  return (
    <SkeletonRegion className="flex min-h-svh w-full lg:bg-sidebar">
      <div className="hidden w-(--sidebar-width,16rem) shrink-0 flex-col gap-2 p-2 lg:flex">
        <div className="px-2 py-1">
          <Line width="w-36" />
        </div>
        <div className="flex flex-col gap-1 p-2">
          {NAV_KEYS.map((key) => (
            <div key={key} className="flex h-8 items-center gap-2 px-2">
              <Bone className="size-4" />
              <Line width="w-28" />
            </div>
          ))}
        </div>
      </div>
      <div className="bg-background flex min-w-0 flex-1 flex-col lg:m-2 lg:ml-0 lg:rounded-xl lg:shadow-sm">
        <div className="flex h-14 shrink-0 items-center gap-2 rounded-t-xl border-b px-4">
          <Bone className="size-7" />
          <Line width="w-40" />
          <Bone className="ml-auto size-9" />
        </div>
        <div className="bg-muted/50 flex min-w-0 flex-1 flex-col gap-6 rounded-b-xl p-4 md:p-6">
          <HeaderSkeleton />
          <TableSkeleton
            card={{}}
            columns={[
              { cell: 'text', widths: ['w-40', 'w-32', 'w-48'], primary: true },
              { cell: 'muted', widths: ['w-28', 'w-36'] },
              { cell: 'badge', widths: ['w-20'] },
              { cell: 'muted', widths: ['w-16', 'w-20'], align: 'end' },
            ]}
          />
        </div>
      </div>
    </SkeletonRegion>
  )
}
